<div class="ui basic segment">
  <form class="ui form" [formGroup]="registrationForm">
    <div class="ui basic segment">
      <h3 class="ui header">Register on SignGaze</h3>
    </div>
    <div class="field">
      <signgaze-social-login></signgaze-social-login>
    </div>
    <div class="ui horizontal divider segment">Or Signup with</div>
    <div
      class="field"
      [class.error]="
        registrationForm?.controls.displayName.errors &&
        registrationForm?.get('displayName').dirty
      "
    >
      <div class="ui large input">
        <input
          type="text"
          placeholder="Your Name"
          formControlName="displayName"
        />
      </div>
    </div>
    <div
      class="field"
      [class.error]="
        registrationForm?.controls.email.errors &&
        registrationForm?.get('email').dirty
      "
    >
      <div class="ui large input">
        <input type="text" placeholder="Your Email" formControlName="email" />
      </div>
    </div>
    <div
      class="field"
      [class.error]="
        registrationForm?.controls.password.errors &&
        registrationForm?.get('password').dirty
      "
    >
      <div class="ui fluid icon large input">
        <input
          type="Password"
          placeholder="Password"
          formControlName="password"
          #password
        />
        <a
          href="javascript:void(0)"
          (click)="getPasswordInput(password)"
          class="field-icon"
          ><i class="eye icon"></i
        ></a>
      </div>
      <div
        class="ui red basic tiny pointing label"
        *ngIf="
          registrationForm?.controls.password.errors &&
          registrationForm?.get('password').dirty
        "
      >
        {{ (registrationForm?.controls.password)['errorMessage'] }}
      </div>
    </div>
    <div
      class="field"
      [class.error]="
        registrationForm?.controls.confirmPassword.errors &&
        registrationForm?.get('confirmPassword').dirty
      "
    >
      <div class="ui fluid icon large input">
        <input
          type="Password"
          placeholder="Confirm Password"
          formControlName="confirmPassword"
          #confirmPassword
        />
        <a
          href="javascript:void(0)"
          (click)="getPasswordInput(confirmPassword)"
          class="field-icon"
          ><i class="eye icon"></i
        ></a>
      </div>
      <div
        class="ui red basic tiny pointing label"
        *ngIf="
          registrationForm?.controls.confirmPassword.errors &&
          registrationForm?.get('confirmPassword').dirty
        "
      >
        {{ (registrationForm?.controls.confirmPassword)['errorMessage'] }}
      </div>
    </div>
    <div class="inline field">
      <fui-checkbox
        [(ngModel)]="isConfirmToTermsAndConditions"
        [ngModelOptions]="{ standalone: true }"
        >I agree to the terms and conditions</fui-checkbox
      >
    </div>
    <button
      class="ui large secondary circular fluid button"
      [disabled]="registrationForm?.invalid || !isConfirmToTermsAndConditions"
      (click)="registerUser()"
      [ngClass]="{ 'elastic loading': isSubmitted }"
    >
      Register
    </button>
  </form>
</div>
